<template>
  <main class="page certification">
    <section class="identity-section">
      <h1>上传身份证</h1>
      <div class="cards">
        <label v-for="item in cards" :key="item.key" class="card-upload">
          <span class="card-image">
            <img :src="previews[item.key] || item.image" :alt="item.label" />
          </span>
          <span class="upload-copy"
            >上传身份证 <em>{{ item.label }}</em></span
          >
          <input
            type="file"
            accept="image/*"
            @change="choose($event, item.key)"
          />
        </label>
      </div>
    </section>

    <section class="form-section">
      <label class="form-row">
        <span>姓名</span>
        <input v-model="name" type="text" placeholder="请输入您的真实姓名" />
        <button
          v-if="name"
          type="button"
          class="clear-input"
          aria-label="清空姓名"
          @click.prevent="name = ''"
        >
          <van-icon name="clear" />
        </button>
      </label>
      <label class="form-row">
        <span>身份证号码</span>
        <input
          v-model="cardNo"
          type="text"
          inputmode="text"
          maxlength="18"
          placeholder="请输入您的身份证号码"
        />
        <button
          v-if="cardNo"
          type="button"
          class="clear-input"
          aria-label="清空身份证号码"
          @click.prevent="cardNo = ''"
        >
          <van-icon name="clear" />
        </button>
      </label>
      <button
        type="button"
        class="form-row optional-toggle"
        @click="showOptional = !showOptional"
      >
        <span>选填信息</span>
        <van-icon :name="showOptional ? 'arrow-up' : 'arrow-down'" />
      </button>
      <template v-if="showOptional">
        <label class="form-row optional-detail">
          <span>地址</span>
          <input
            v-model="address"
            type="text"
            placeholder="请输入您的身份证地址"
          />
          <button
            v-if="address"
            type="button"
            class="clear-input"
            aria-label="清空地址"
            @click.prevent="address = ''"
          >
            <van-icon name="clear" />
          </button>
        </label>
        <button
          type="button"
          class="form-row optional-detail date-row"
          @click="openDatePicker('start')"
        >
          <span>起始日期</span>
          <span :class="{ placeholder: !validityStart }">
            {{ validityStart || "请输入证件有效期起始日期" }}
          </span>
        </button>
        <div class="form-row end-date-row optional-detail">
          <span>结束日期</span>
          <button
            type="button"
            class="date-value"
            :class="{ placeholder: !validityEnd && !isLongTerm }"
            :disabled="isLongTerm"
            @click="openDatePicker('end')"
          >
            {{
              isLongTerm ? "长期" : validityEnd || "请输入证件有效期结束日期"
            }}
          </button>
          <div class="long-term-option">
            <van-checkbox
              v-model="isLongTerm"
              class="long-term-checkbox"
              shape="round"
              checked-color="#D3936A"
              icon-size="14px"
              @change="changeLongTerm"
            >
              长期
            </van-checkbox>
          </div>
        </div>
      </template>
      <label class="form-row">
        <span>推荐人工号</span>
        <input
          v-model="referrerNo"
          type="number"
          maxlength="4"
          placeholder="请输入推荐人工号"
        />
        <button
          v-if="referrerNo"
          type="button"
          class="clear-input"
          aria-label="清空推荐人工号"
          @click.prevent="referrerNo = ''"
        >
          <van-icon name="clear" />
        </button>
      </label>
    </section>

    <div class="agreement-line">
      <van-checkbox v-model="agreed" icon-size="14px" shape="square" />
      <span>
        <span class="agreement-consent" @click="toggleAgreement"
          >我已阅读并同意</span
        >
        <span class="agreement-names"
          >《电子签名授权书》《个人征信授权书》《综合授权书》</span
        >
      </span>
    </div>

    <button
      type="button"
      class="confirm-button"
      :disabled="!canSubmit"
      @click="next"
    >
      确定
    </button>
    <button type="button" class="exit-button" aria-label="退出" @click="exit">
      <img
        src="../assets/images/tuichu.png"
        alt=""
      />
    </button>

    <van-popup v-model="showDatePicker" position="bottom" class="date-popup">
      <van-datetime-picker
        v-model="pickerDate"
        type="date"
        :min-date="dateType === 'start' ? startMinDate : endMinDate"
        :max-date="dateType === 'start' ? startMaxDate : endMaxDate"
        @confirm="confirmDate"
        @cancel="showDatePicker = false"
      />
    </van-popup>

    <div v-if="showConfirmation" class="confirmation-overlay">
      <section
        class="confirmation-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirmation-title"
      >
        <h2 id="confirmation-title">提示</h2>
        <p class="confirmation-warning">请您确认认证信息，提交后无法再修改</p>
        <dl class="confirmation-details">
          <div>
            <dt>姓名：</dt>
            <dd>{{ name }}</dd>
          </div>
          <div>
            <dt>身份证：</dt>
            <dd>{{ cardNo }}</dd>
          </div>
          <div>
            <dt>民族：</dt>
            <dd>{{ ethnicity }}</dd>
          </div>
          <div>
            <dt>地址：</dt>
            <dd>{{ address }}</dd>
          </div>
        </dl>
        <div class="confirmation-actions">
          <button type="button" @click="showConfirmation = false">修改</button>
          <button
            type="button"
            class="confirmation-submit"
            @click="confirmSubmission"
          >
            确认
          </button>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import front from "../assets/images/id-card-front.png";
import back from "../assets/images/id-card-back.png";

export default {
  name: "Certification",
  data: () => ({
    name: "林若安",
    cardNo: "990101199001010019",
    ethnicity: "汉族",
    address: "星河省云川市新月区晨光路88号",
    validityStart: "20250101",
    validityEnd: "20341231",
    isLongTerm: false,
    showDatePicker: false,
    dateType: "start",
    pickerDate: new Date(),
    startMinDate: new Date(1980, 0, 1),
    startMaxDate: new Date(),
    endMinDate: new Date(),
    endMaxDate: new Date(new Date().getFullYear() + 30, 11, 31),
    referrerNo: "4827",
    agreed: true,
    showOptional: false,
    showConfirmation: false,
    cards: [
      { key: "front", label: "人像面", image: front },
      { key: "back", label: "国徽面", image: back },
    ],
    previews: {},
  }),
  beforeDestroy() {
    Object.keys(this.previews).forEach((key) =>
      URL.revokeObjectURL(this.previews[key])
    );
  },
  computed: {
    canSubmit() {
      return Boolean(this.name.trim() && this.isValidCardNo(this.cardNo));
    },
  },
  methods: {
    toggleAgreement() {
      this.agreed = !this.agreed;
    },
    isValidCardNo(value) {
      const cardNo = value.trim().toUpperCase();
      if (!/^\d{17}[\dX]$/.test(cardNo) || cardNo.slice(0, 6) === "000000")
        return false;

      const birth = cardNo.slice(6, 14);
      const year = Number(birth.slice(0, 4));
      const month = Number(birth.slice(4, 6));
      const day = Number(birth.slice(6, 8));
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
      )
        return false;

      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const checks = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
      const sum = weights.reduce(
        (total, weight, index) => total + Number(cardNo[index]) * weight,
        0
      );
      return checks[sum % 11] === cardNo[17];
    },
    choose(event, key) {
      const file = event.target.files[0];
      if (!file) return;
      if (this.previews[key]) URL.revokeObjectURL(this.previews[key]);
      this.$set(this.previews, key, URL.createObjectURL(file));
    },
    changeLongTerm() {
      if (this.isLongTerm) this.validityEnd = "";
    },
    openDatePicker(type) {
      this.dateType = type;
      const value = type === "start" ? this.validityStart : this.validityEnd;
      if (value) {
        const year = Number(value.slice(0, 4));
        const month = Number(value.slice(4, 6));
        const day = Number(value.slice(6, 8));
        this.pickerDate = new Date(year, month - 1, day);
      } else {
        this.pickerDate = new Date();
      }
      this.showDatePicker = true;
    },
    confirmDate(value) {
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, "0");
      const day = String(value.getDate()).padStart(2, "0");
      const formatted = `${year}${month}${day}`;
      if (this.dateType === "start") this.validityStart = formatted;
      else this.validityEnd = formatted;
      this.showDatePicker = false;
    },
    exit() {
      this.$router.push("/login");
    },
    next() {
      if (!this.name || !this.cardNo) return this.$toast("请完善身份信息");
      if (!this.isValidCardNo(this.cardNo))
        return this.$toast("请输入正确的身份证号码");
      if (!this.referrerNo.trim()) return this.$toast("请输入推荐人工号");
      if (!this.agreed) return this.$toast("请阅读并同意授权书");
      this.showConfirmation = true;
    },
    confirmSubmission() {
      this.$router.push("/trialByInstallments");
    },
  },
};
</script>

<style lang="scss" scoped>
.certification {
  position: relative;
  min-height: 100vh;
  padding: 30px 17px 120px;
  background: #fff;
  color: #28384f;
}
.identity-section h1 {
  margin: 0 0 5px 4px;
  font-size: 17px;
  font-weight: 500;
}
.cards {
  display: flex;
  gap: 8px;
  margin-bottom: 58px;
}
.card-upload {
  position: relative;
  flex: 1;
  color: #25364d;
  font-size: 14px;
  text-align: center;
}
.card-image {
  display: block;
  padding: 15px;
  border: 1px solid #eef1f4;
  border-radius: 4px;
  box-shadow: 0 1px 5px rgba(42, 56, 83, 0.06);
}
.card-upload img {
  display: block;
  width: 100%;
  height: 98px;
  object-fit: contain;
  background: #fbfcfd;
}
.upload-copy {
  display: block;
  margin-top: 16px;
}
.upload-copy em {
  color: #d3936a;
  font-style: normal;
}
.card-upload input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.form-section {
  margin-bottom: 25px;
}
.form-row {
  display: flex;
  width: 100%;
  min-height: 44px;
  align-items: center;
  padding: 0 15px;
  border: 0;
  border-bottom: 1px solid #edf0f2;
  outline: 0;
  background: transparent;
  color: #344258;
  font: inherit;
  font-size: 14px;
  text-align: left;
}
.form-row > span:first-child {
  width: 94px;
  flex: 0 0 94px;
}
.optional-detail {
  padding-left: 29px;
}
.optional-detail > span:first-child {
  width: 80px;
  flex-basis: 80px;
}
.form-row input {
  min-width: 0;
  flex: 1;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #344258;
  font-size: 14px;
}
.form-row input::placeholder {
  color: #c8ccd3;
}
.clear-input {
  display: flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #c8ccd3;
  font-size: 16px;
}
.date-row {
  justify-content: flex-start;
}
.date-row > span:last-child,
.date-value {
  min-width: 0;
  flex: 1;
  padding: 0;
  border: 0;
  background: transparent;
  color: #344258;
  font: inherit;
  text-align: left;
}
.date-row > span.placeholder,
.date-value.placeholder {
  color: #c8ccd3;
}
.date-value:disabled {
  cursor: not-allowed;
}
.long-term-option {
  display: flex;
  flex: none;
  align-items: center;
  margin-left: 8px;
  white-space: nowrap;
}
.long-term-checkbox {
  flex: none;
  margin-right: 7px;
}
.long-term-option span {
  width: auto;
  flex: none;
}
.optional-toggle {
  justify-content: space-between;
}
.optional-toggle .van-icon {
  color: #7b8999;
  font-size: 16px;
}
.agreement-line {
  display: flex;
  align-items: flex-start;
  padding: 0;
  color: #27384f;
  font-size: 16px;
  line-height: 24px;
}
.agreement-line ::v-deep .van-checkbox {
  flex: none;
  margin: 3px 8px 0 0;
}
.agreement-names {
  color: #d3936a;
}
.confirm-button {
  width: 100%;
  height: 50px;
  margin-top: 68px;
  border: 0;
  border-radius: 7px;
  background: linear-gradient(90deg, #e1a379 0%, #b36e47 100%) !important;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
}
.confirm-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.exit-button {
  position: fixed;
  right: max(13px, calc((100vw - 420px) / 2 + 13px));
  bottom: 80px;
  display: flex;
  width: 55px;
  height: 55px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #eceeef;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(42, 56, 83, 0.08);
}
.exit-button img {
  display: block;
  width: 55px;
  height: 55px;
  object-fit: contain;
}
.date-popup ::v-deep .van-picker__toolbar {
  height: 48px;
}
.date-popup ::v-deep .van-picker__cancel {
  color: #8f9daf;
}
.date-popup ::v-deep .van-picker__confirm {
  color: #36558f;
}
.date-popup ::v-deep .van-picker-column__item {
  font-size: 16px;
}
.confirmation-overlay {
  position: fixed;
  z-index: 2000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.7);
}
.confirmation-modal {
  width: min(366px, 100%);
  overflow: hidden;
  border-radius: 15px;
  background: #fff;
  color: #222;
}
.confirmation-modal h2 {
  margin: 0;
  padding: 25px 22px 13px;
  font-size: 17px;
  font-weight: 400;
  text-align: center;
}
.confirmation-warning {
  margin: 0;
  padding: 5px 23px 7px;
  color: #df8a62;
  font-size: 16px;
  line-height: 24px;
}
.confirmation-details {
  margin: 0;
  padding: 0 23px 31px;
  font-size: 16px;
  line-height: 30px;
}
.confirmation-details div {
  display: flex;
}
.confirmation-details dt {
  width: 114px;
  flex: none;
}
.confirmation-details dd {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
}
.confirmation-actions {
  display: flex;
  border-top: 1px solid #f0f0f0;
}
.confirmation-actions button {
  width: 50%;
  height: 50px;
  padding: 0;
  border: 0;
  background: #fff;
  color: #333;
  font-size: 17px;
}
.confirmation-actions button + button {
  border-left: 1px solid #f0f0f0;
}
.confirmation-actions .confirmation-submit {
  color: #df8a62;
}
</style>
